import React, { useState, useEffect } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { renderError } from "../../utils/ModuleFunctions";
import { FaEnvelopeOpen, FaUser, FaLock, FaAdn } from "react-icons/fa";
import { useParams, useNavigate } from "react-router-dom";
import AxiosInstance from "../../utils/AxiosInstance";
import { ToastContainer, toast } from "react-toastify";
import * as Yup from "yup";

const Profile = () => {
	const [image, setImage] = useState();
	const [user, setUser] = useState();
	const { id } = useParams();
	const navigate = useNavigate();
	const url = `${process.env.REACT_APP_API_URL}/api/images/users`;

	useEffect(() => {
		const fetchUser = async () => {
			const res = await AxiosInstance({
				method: "get",
				url: `/api/v1/users/${id}`,
			});
			setUser(res.data.user);
		};
		fetchUser();
		console.log(id);
	}, [id]);

	const validationSchema = Yup.object({
		email: Yup.string()
			.email("input field must be an email")
			.required("Email is Required"),
		username: Yup.string()
			.min(4, "character too short, should be 4 and above")
			.required("username  is Required"),
	});

	const initialValues = {
		email: user && (user?.email ?? ""),
		username: user && (user?.username ?? ""),
		role: user && (user?.role ?? ""),
	};

	const onSubmit = async (values) => {
		values.image = image;
		let formData = new FormData();
		formData.append("email", values.email);
		formData.append("username", values.username);
		formData.append("image", values.image);
		console.log(values);
		try {
			await AxiosInstance({
				method: "post",
				url: `/api/v1/users//update/${id}`,
				headers: {
					accept: "application/json",
				},
				data: formData,
			});

			window.location.assign(`/admin/profile/${id}`);
		} catch (err) {
			console.log("logged Error", err?.response?.data?.message);
			if (err?.response.data?.message) {
				if (err?.response?.data?.message.startsWith("Can't extract")) {
					toast.error(
						"Please provide a correct coodinates for the Longitude and the Latitude",
						{ position: "top-center" }
					);
				} else {
					toast.error(err?.response?.data?.message, {
						position: "top-center",
					});
				}
			}
		}
	};
	return (
		<>
			<div className="page-container  mt-5">
				<h2 className="text-center"> Edit Your Profile</h2>
				<Formik
					enableReinitialize={true}
					initialValues={initialValues}
					validationSchema={validationSchema}
					onSubmit={async (values, { resetForm }) => {
						await onSubmit(values);
					}}
				>
					<Form>
						<div className="grid-profile">
							<div className="left-side">
								<h5 className="text-center">Your Profile Picture</h5>
								<div className="img-area">
									{user && user?.image ? (
										<img
											src={`${url}/${user.image}`}
											className="img-fluid img-sidebar"
											style={{ width: 150, height: 150, borderRadius: "50%" }}
											alt="..."
										/>
									) : (
										<img
											src={`${url}/profile_pic.jpg`}
											className="img-fluid img-sidebar"
											style={{ width: 150, height: 150, borderRadius: "50%" }}
											alt="..."
										/>
									)}
									<div>
										<label>upload Cover</label>
										<input
											type="file"
											className="form-control"
											onChange={(e) => setImage(e.currentTarget.files[0])}
										/>
										<ErrorMessage name="coverImage" render={renderError} />
									</div>
									<p className="notice-photo">
										!!This photo will appear on the dashboard sidebar, when you
										login again!!
									</p>
								</div>
							</div>
							<div className="right-side">
								<div>
									<div className="d-flex">
										<FaUser size={25} />
										<span className="p-heading">Username</span>
									</div>
									<Field
										type="text"
										className="form-control"
										placeholder="Your Username"
										name="username"
									/>
									<p className="eg-text">
										<span className="required">*</span>my-name
									</p>
									<ErrorMessage name="username" render={renderError} />
								</div>
								<div className="mb-4">
									<div className="d-flex">
										<FaAdn size={25} />
										<span className="p-heading">Role</span>
									</div>
									<Field
										type="text"
										className="form-control"
										placeholder="Your Username"
										name="role"
										disabled
									/>
								</div>
								<div>
									<div>
										<FaEnvelopeOpen size={25} />
										<span className="p-heading">Email</span>
									</div>
									<Field
										type="text"
										name="email"
										className="form-control"
										disabled
									/>
									<p className="eg-text">
										{" "}
										<span className="required">*</span>user@kossass.com
									</p>
									<ErrorMessage name="email" render={renderError} />
								</div>
								{/* <div>
									<div>
										<FaLock size={25} />
										<span className="p-heading">Password</span>
									</div>
									<Field type="text" name="password" className="form-control" />
									<p className="eg-text">
										{" "}
										<span className="required">*</span>hidden
									</p>
									<ErrorMessage name="password" render={renderError} />
								</div> */}

								<div className="profile-bottom-flex">
									<div className="mt-3">
										<button type="submit" className="btn is-primary">
											Submit
										</button>
									</div>
									<div className="mt-3">
										<button type="cancel" className="btn btn-danger">
											Cancel
										</button>
									</div>
								</div>
							</div>
						</div>
					</Form>
				</Formik>
			</div>
		</>
	);
};

export default Profile;
